
class HighlightedProductContainer extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.isConnected && !this.initialized) {
        this.initialized = true;
        this.waitForStylesheetAndLoad();
      }
    }

    waitForStylesheetAndLoad() {
      if (document.readyState === 'complete') {
        this.initSwiper();
      } else {
        window.addEventListener('load', () => {
          this.initSwiper();
        });
      }
    }

    initSwiper() {
      this.swiper = new Swiper('.highlighted-section-container', {
        loop: false,
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 15,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.HighlightedSliderNav__Next',
          prevEl: '.HighlightedSliderNav__Prev',
        },
        breakpoints: {
          591: {
            slidesPerView: 2,
          },
          1024: {
            loop: false,
            slidesPerView: 2.4,
            slidesPerGroup: 1,
            spaceBetween: 30,
            centeredSlides: true,
          },
          1280: {
            loop: false,
            slidesPerView: 3.2,
            slidesPerGroup: 1,
            spaceBetween: 30,
            centeredSlides: true,
          },
          1441: {
            loop: false,
            slidesPerView: 3.6,
            slidesPerGroup: 1,
            spaceBetween: 30,
            shortSwipes: false,
            preventClicksPropagation: false,
            preventClicks: false,
            centeredSlides: true,
          }
        },
      });
      this.swiper.slideTo(2, 0);
    }
}
customElements.define('highlighted-product-container', HighlightedProductContainer);

// dynamic container height code starts here
const containerHeight = $('.highlighted-slider').height();
$('.highlighted-slider .highlighted_product_card').css('height', containerHeight + 'px');
// dynamic container height code ends here
